<template>
    <div class="form-group" :class="classObject">
        <template v-if="mode === 'show'">
            <label
                v-if="displayLabel === true && getShowRouteName() == null || getShowId() == null"
                class="control-label col-md-3"
            >
                {{ title }}
            </label>
            <label v-else-if="displayLabel === true" class="control-label col-md-3">
                <a :href="generateRoute()" target="_blank">{{ title }} <i class="fa fa-link"></i></a>
            </label>
            <div :class="inputClass">
                <input
                    :id="id"
                    v-model="val"
                    class="form-control"
                    lang="en"
                    :disabled="disabled"
                    type="number" :step="step"
                    :min="min"
                    :max="max"
                    @keypress="isNumber"
                    @change="$emit('change', $event)"
                >
                <span v-if="allowSingleEdit === true" class="fast-edit-button" @click="mode = 'edit'">
                    <i class="fa fa-pencil-square"></i>
                </span>
                <span v-if="errorText" class="help-block">
                    <p> {{errorText}} </p>
                </span>
            </div>
        </template>
        <template v-if="mode === 'edit'">
            <label
                v-if="displayLabel === true && getShowRouteName() == null || getShowId() == null"
                class="control-label col-md-3">
                {{ title }}
            </label>
            <label v-else-if="displayLabel === true" class="control-label col-md-3">
                <a :href="generateRoute()" target="_blank">{{ title }} <i class="fa fa-link"></i></a>
            </label>
            <div :class="inputClass">
                <input
                    :id="id"
                    v-model="editValue"
                    class="form-control"
                    lang="en" type="number"
                    :step="step" :min="min"
                    @keypress="isNumber"
                    @change="$emit('change', $event)"
                >
                <template v-if="processEdit === true">
                    <span class="fast-save-process">
                        <i class="fa fa-spin fa-spinner"></i>
                    </span>
                </template>
                <template v-else>
                    <span v-if="allowSingleEdit === true" class="fast-save-button" @click="saveEdit()">
                        <i class="fa fa-save"></i>
                    </span>
                    <span v-if="allowSingleEdit === true" class="fast-cancel-button" @click="editValue = val; mode = 'show'">
                        <i class="fa fa-ban"></i>
                    </span>
                </template>
                <span v-if="errorText" class="help-block">
                    <p> {{errorText}} </p>
                </span>
            </div>
        </template>
    </div>
</template>

<script>
import BaseInput from './baseInput.vue'
import toastr from '../../js/toastr'

export default {
  extends: BaseInput,
  props: {
    showLabel: {
      type: Boolean,
      default: true
    },
    step: {
      type: [Number, String],
      default: 1
    },
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 99999999999999
    },
    labelSize: {
      type: [Number, String],
      default: 3
    },
    index: {
      type: [String, Number],
      default: null
    },
    displayLabel: {
      type: Boolean,
      default: true
    },
    route: {
      type: Boolean,
      default: true
    },
    allowSingleEdit: {
      type: Boolean,
      default: false
    },
    float: {
      type: Boolean,
      default: true
    },
    negative: {
      type: Boolean,
      default: false
    },
    saveCallback: {
      type: Function,
      default: null
    },
    showRouteName: {
      type: String,
      default: null
    },
    showIdParamName: {
      type: String,
      default: 'id'
    },
    showAdditionalParams: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      id: `form_${this.name}`,
      val: null,
      editValue: null,
      processEdit: false,
      errorText: false,
      mode: 'show',
      labelClass: `control-label col-md-${this.labelSize}`,
      inputClass: `col-md-${12 - this.labelSize}`
    }
  },
  watch: {
    errors: function (value) {
      if (this.index !== null && value[this.index]) {
        if (value[this.index][this.name]) {
          this.errorText = Object.values(value[this.index][this.name]).join()
          this.error = true
        } else {
          this.errorText = false
          this.error = false
        }
      }
    },
    val: function (value) {
      this.$emit('input', value)
      this.editValue = value
    },
    value: function (v) {
      this.val = v
    }
  },
  mounted: function () {
    if (undefined !== this.value && null !== this.value) {
      this.val = this.value
    }

    this.$emit('input', this.value)
  },
  methods: {
    isNumber(evt) {
      if (evt.metaKey) {
        return
      }
      const key = evt.key
      let val = this.val ? this.val : ''
      if (key === '-') {
        val = key + val
      } else {
        val += key
      }
      const pattern = this.getProperPattern()
      const valid = (val.match(pattern) || []).length > 0
      if (this.float) {
        const isFirstDot = (val.match(/^\.$/) || []).length > 0
        if (isFirstDot) {
          this.val = val.replace(/^\.$/, '0')

          return
        }
      }
      if (!valid) {
        evt.preventDefault()
      }
    },
    getProperPattern() {
      const posFloatPattern = /^\d*\.?\d{0,2}$/
      const negFloatPattern = /^-?\d*\.?\d{0,2}$/
      const posIntPattern = /^\d*$/
      const negIntPattern = /^-?\d*$/
      if (this.float && this.negative) {
        return negFloatPattern
      } else if (this.float && !this.negative) {
        return posFloatPattern
      } else if (!this.float && this.negative) {
        return negIntPattern
      } else if (!this.float && !this.negative) {
        return posIntPattern
      }
    },
    getShowRouteName () {
      if (this.route === false) {
        return null
      }
      if (this.showRouteName !== null) {
        if (this.showRouteName === false) {
          return null
        }
        return this.showRouteName
      }

      try {
        let params = {}
        params[this.showIdParamName] = this.getShowId()
        Routing.generate(`${this.name}_show`, Object.assign(params, this.showAdditionalParams))
      } catch (err) {
        return null
      }

      return `${this.name}_show`
    },
    generateRoute () {
      let params = {}
      params[this.showIdParamName] = this.getShowId()
      return Routing.generate(this.getShowRouteName(), Object.assign(params, this.showAdditionalParams))
    },
    getShowId () {
      return this.value
    },
    saveEdit () {
      this.processEdit = true
      if (this.saveCallback === null) {
        this.val = this.editValue
        this.$emit('editsaved', this.editValue)
        this.processEdit = false
        this.mode = 'show'
      } else {
        this.saveCallback(this.editValue)
          .then(() => {
            this.val = this.editValue
            this.mode = 'show'
            this.$emit('editsaved', this.editValue)
            toastr.success(Translator.trans('form.updated'))
          })
          .catch(data => {
            toastr.error(Translator.trans(data.message))
            this.$emit('editerror', data)
          })
          .finally(() => {
            this.processEdit = false
          })
      }
    }
  }
}
</script>

<style>
input[type=number]::-webkit-inner-spin-button {
  height: 30px;
  font-size: 20px;
}
</style>
